import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import { round6 } from 'utilities/math';

import {
  getTableData,
  getNumericalRowDataSet,
  getConfidenceInterval,
  getLimits,
  getStandardError,
  getDF,
  getMeanOfSampleDiff,
  getPairedTTwoGroups
} from 'store/scenes/inferentialStatistics/selectors';
import { getVisibleNumericalSelectedParametersNames } from 'store/dataset';

import { getTableHeadersForPairedT } from '../shared';

const PairedTConfidenceInterval = () => {
  const tableData = useSelector(state => getTableData(state));
  const confidenceInterval = useSelector(state => getConfidenceInterval(state));
  const standardError = useSelector(state => getStandardError(state));
  const { lowerLimit, upperLimit } = useSelector(state => getLimits(state));
  const df = useSelector(state => getDF(state));
  const isDataSetAvailable = useSelector(state => getVisibleNumericalSelectedParametersNames(state).length > 1 && getPairedTTwoGroups(state) || false);
  const meanOfSampleDiff = useSelector(state => getMeanOfSampleDiff(state));
  const numericalRowDataSet = useSelector(state => getNumericalRowDataSet(state));

  const tableHeaders = getTableHeadersForPairedT(isDataSetAvailable, !!numericalRowDataSet);

  return (
    <div className="content-item">
      <h3 className="mb-20">Paired <i>t</i> Confidence Interval Summary</h3>
      <div className="mb-5 pl-5 font-900">
        {isDataSetAvailable && (
          <p className="mb-5">
            Differences = x<sub>1</sub> - x<sub>2</sub>
          </p>
        )}
        <p>
          μ<sub><i>d</i></sub>{' '}: mean of population differences
        </p>
        <p>
          {confidenceInterval}% Confidence Interval for μ<sub><i>d</i></sub>
        </p>
      </div>
      <table className="infStatMarkup-table">
        <tbody>
          {isDataSetAvailable && (
            <tr>
              <td>Mean of Sample Differences</td>
              <td>{round6(meanOfSampleDiff)}</td>
            </tr>)
          }
          <tr>
            <td>Lower Limit </td>
            <td>
              <span>{round6(lowerLimit)}</span>
            </td>
          </tr>
          <tr>
            <td>Upper Limit </td>
            <td>
              <span>{round6(upperLimit)}</span>
            </td>
          </tr>
          <tr>
            <td>df</td>
            <td>
              <span>{round6(df)}</span>
            </td>
          </tr>
          {isDataSetAvailable && (
            <tr>
              <td>Standard Error</td>
              <td>{round6(standardError)}</td>
            </tr>)
          }
        </tbody>
      </table>
      <h3>Descriptive Statistics of Sample</h3>
      <Table tableHeaders={tableHeaders} tableData={tableData} />
    </div>
  );
};


export default PairedTConfidenceInterval;
